import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';

const ButtonLink = ({ to, className = '', children }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleClick = (e) => {
        if (loading) return;

        setLoading(true);
        setTimeout(() => {
            navigate(to)
            setLoading(false);
        }, 300);
    };

    return (
        <LoadingButton
            onClick={handleClick}
            loading={loading}
            className={className}
            variant="contained"
            sx={{
                paddingX: 2,
                paddingY: 1,
                backgroundColor: '#4d4d4d', // Black
                '&:hover': {
                    backgroundColor: '#3d3d3d', // Slightly lighter black for hover
                },
                borderTop: '2px solid #2d2d2d',
                borderRight: '2px solid #2d2d2d',
                borderLeft: '2px solid #2d2d2d',
                borderBottom: '8px solid #2d2d2d',
                '&:active': {
                    borderBottom: '4px solid #2d2d2d',
                },
                color: '#ffffff',
                fontSize: 16,
                textTransform: 'none',
                borderRadius: '12px',
            }}
        >
            {children}
        </LoadingButton>
    );
};

export default ButtonLink;
